"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getCofValue = exports.initCofConfig = void 0;
var configs_web_1 = require("@snapchat/configs-web");
var grapheneMetrics_1 = require("../grapheneMetrics");
var logger_1 = require("../logger");
var environment_1 = require("../environment");
var authState_1 = require("../auth/authState");
var userAgent_1 = __importStar(require("./userAgent"));
var domain_1 = require("./domain");
var authState_2 = require("../auth/authState");
var ssoClientConfig_1 = require("../auth/ssoClientConfig");
var CONFIG_NAMES = [
    "BLIZZARD_WEB_BATCHING_ENABLED",
    "BLIZZARD_WEB_BATCHING_SIZE_LIMIT",
    "BLIZZARD_WEB_BATCHING_UPLOAD_TIMEOUT",
];
var configResultsPromise = undefined;
function initCofConfig() {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            configResultsPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                var ssoToken, cofSettingsMetadata, cofSettingsMap, cofSettings, results, _a;
                var _b, _c, _d, _e;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            log.debug("#initCofConfig");
                            return [4, (0, authState_1.getAuthState)()];
                        case 1:
                            ssoToken = (_f.sent()).ssoToken;
                            cofSettingsMetadata = __assign({}, (ssoToken ? { Authorization: "Bearer ".concat(ssoToken) } : {}));
                            cofSettingsMap = (_b = {},
                                _b[ssoClientConfig_1.SsoClientId.DESKTOP_WEB] = {
                                    host: domain_1.DWEB_PROD_HOST,
                                    metadata: __assign({}, cofSettingsMetadata)
                                },
                                _b[ssoClientConfig_1.SsoClientId.SNAPCHAT_COM] = {
                                    metadata: __assign((_c = {}, _c[userAgent_1.USER_AGENT_HEADER_KEY] = (0, userAgent_1["default"])(), _c), cofSettingsMetadata)
                                },
                                _b);
                            cofSettings = (0, authState_2.getSsoClientId)() in cofSettingsMap
                                ? cofSettingsMap[(0, authState_2.getSsoClientId)()]
                                : {
                                    metadata: __assign((_d = {}, _d[userAgent_1.USER_AGENT_HEADER_KEY] = (0, userAgent_1["default"])(), _d), cofSettingsMetadata)
                                };
                            log.debug("#initCofConfig: using config", cofSettings);
                            (0, configs_web_1.initConfigsClient)(cofSettings);
                            (0, configs_web_1.registerPropertyValueProvider)(configs_web_1.ClientTargetingExpressionProperty.BUILD_FLAVOR, function () { return (0, environment_1.getAppEnvironment)().appBuild; });
                            if (!((0, authState_2.getSsoClientId)() === ssoClientConfig_1.SsoClientId.DESKTOP_WEB)) return [3, 3];
                            return [4, (0, configs_web_1.targetingQuery)({
                                    configNames: __spreadArray([], __read(CONFIG_NAMES), false)
                                }, (_e = {},
                                    _e[userAgent_1.USER_AGENT_HEADER_KEY] = (0, userAgent_1["default"])({ appName: "SnapchatWeb" }),
                                    _e))];
                        case 2:
                            _a = (_f.sent()).configResults;
                            return [3, 5];
                        case 3: return [4, (0, configs_web_1.targetingQuery)({
                                configNames: __spreadArray([], __read(CONFIG_NAMES), false)
                            })];
                        case 4:
                            _a = (_f.sent()).configResults;
                            _f.label = 5;
                        case 5:
                            results = _a;
                            log.debug("#initCofConfig: COF initialized", results);
                            return [2, results];
                    }
                });
            }); })();
            return [2, configResultsPromise];
        });
    });
}
exports.initCofConfig = initCofConfig;
function getCofValue(configName, getter) {
    return __awaiter(this, void 0, void 0, function () {
        function logFailureThenUndefined(metricsName, dimensions) {
            grapheneMetrics_1.blizzardGraphene.increment({
                metricsName: metricsName,
                dimensions: __assign({ config_name: configName }, dimensions)
            });
            return undefined;
        }
        var configResults, e_1, evaluatedConfig, value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    log.debug("#getCofValue(".concat(configName, ")"));
                    if (!configResultsPromise) {
                        throw new Error("getCofValue called before initCofConfig");
                    }
                    configResults = [];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, configResultsPromise];
                case 2:
                    configResults = _a.sent();
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    log.error("Failure resolving COF config", e_1);
                    return [2, logFailureThenUndefined(grapheneMetrics_1.COF_FAILURE)];
                case 4:
                    evaluatedConfig = (0, configs_web_1.getEvaluatedCofConfig)(configResults, configName);
                    if (evaluatedConfig === undefined) {
                        return [2, logFailureThenUndefined(grapheneMetrics_1.COF_EMPTY_CONFIG)];
                    }
                    if (evaluatedConfig.value === undefined) {
                        return [2, logFailureThenUndefined(grapheneMetrics_1.COF_EMPTY_CONFIG_VALUE)];
                    }
                    value = getter(evaluatedConfig.value);
                    if (value === undefined) {
                        return [2, logFailureThenUndefined(grapheneMetrics_1.COF_UNSUPPORTED_CONFIG_TYPE, {
                                type: typeof evaluatedConfig.value
                            })];
                    }
                    return [2, value];
            }
        });
    });
}
exports.getCofValue = getCofValue;
var log = (0, logger_1.getLogger)("cofConfig");
//# sourceMappingURL=cof.js.map